var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import InputMask from 'react-input-mask';
import Input, { InputProps } from "./Input";
var DateInput = function (_a) {
    var format = _a.format, props = __rest(_a, ["format"]);
    var mask = format.replace(/\w/g, '9');
    return (React.createElement(InputMask, __assign({}, props, { mask: mask, maskPlaceholder: format }),
        React.createElement(Input, { type: "text", inputMode: "decimal" })));
};
DateInput.defaultProps = {
    format: 'TT.MM.JJJJ',
};
export default DateInput;
//# sourceMappingURL=DateInput.js.map